import React from 'react';

/** The client a workspace is being started for, where the launcher knows one. */
export type LaunchClient = { id: string; name: string };

/**
 * Provided around a launch form so the file pickers inside it can put that
 * client's own files first, without every form in between passing it down.
 */
export const LaunchClientContext = React.createContext<LaunchClient | null>(null);

export const useLaunchClient = () => React.useContext(LaunchClientContext);
